import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import {
    setColor,
    setColorBackground,
    nextStep,
    changeLevel,
    changeImageKey,
    setColorText,
    ifloorplanStateAdd,
    changeCamPosition,
    addPlan,
    changePannellumKey
} from '../redux/actions/actions';
import EditTextBlock from './EditTextBlock.js';
import Cam from './Cam';
import ButtonMarker from './ButtonMarker';
import Client from './Client';
import Marker from './Marker';
import { DraggableCore } from 'react-draggable';
import { Rnd } from 'react-rnd';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import CropTool from './CropTool';
import { Pannellum } from "../../Ifloorplan/components/pannellum-react";
import Pan360Tool from './Pan360Tool';

const CamsPosition = (props) => {
    const ifloorplanObj = props.ifloorplanNowState; //last ifloor plan obj
    let screenSizeRatio = window.innerWidth / (window.innerHeight - 46);
    let [_width, _height] = screenSizeRatio < 1.7777 ? ["99vw", "55.69vw"] : ["calc((99vh - 80px) * 16/9)", "calc(99vh - 80px)"];
    let screenWidth = screenSizeRatio < 1.7777 ? window.innerWidth * 99 / 100 : (window.innerHeight * 99 / 100 - 80) * 1.7777;
    let screenHeight = screenSizeRatio < 1.7777 ? window.innerWidth * 55.69 / 100 : (window.innerHeight * 99 / 100 - 80);
    const [planImage, setPlanImage] = useState({
        naturalHeight: 0,
        naturalWidth: 0
    });
    const [viewHeight, setViewHeight] = useState(screenSizeRatio < 1.7777 ? 55.69 * window.innerWidth / 100 : (99 * window.innerHeight / 100 - 80))
    const [hoverBlockLeft, setHoverBlockLeft] = useState(false);  //hover cams
    const [hoverBlockRight, setHoverBlockRight] = useState(false); //hover cams
    const [rotation, setRotation] = useState(0);  //cam rotation
    const [tabsStyle, setTabsStyle] = useState(JSON.parse(ifloorplanObj.tabs_style));
    const [mediaTabs, setMediaTabs] = useState([]);
    const [tabs, setTabs] = useState([]);
    const [isPanning, setIsPanning] = useState(false);
    const [isFirstMarker, setIsFirstMarker] = useState(false);
    const [panView, setPanView] = useState({
        yaw: props.pannellum_key >= 0 ? ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].yaw : 0,
        pitch: props.pannellum_key >= 0 ? ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].pitch : 0,
        hfov: props.pannellum_key >= 0 ? ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].hfov : 0
    });
    const [resizingImage, setResizingImage] = useState(0) // This keep changing during resizing
    const [imageWrapStyle, setImageWrapStyle] = useState({
        position: 'absolute',
        width: `${ifloorplanObj.img_width}%`,
        height: `${ifloorplanObj.img_height}%`,
        top: `${ifloorplanObj.img_pos_y}%`,
        left: `${ifloorplanObj.img_pos_x}%`
    });
    const [planWrapStyle, setPlanWrapStyle] = useState({
        position: 'absolute',
        width: ifloorplanObj.level[props.levelNowId].plan_width,
        top: ifloorplanObj.level[props.levelNowId].plan_pos_y,
        left: ifloorplanObj.level[props.levelNowId].plan_pos_x
    });
    const [addressWrapStyle, setAdsressWrapStyle] = useState({
        position: 'absolute',
        color: props.text_color,
        top: ifloorplanObj.addressPosition_y,
        left: ifloorplanObj.addressPosition_x,
        width: ifloorplanObj.addressInputWidth,
        height: ifloorplanObj.addressInputHeight,
    });
    const [clientWrapStyle, setClientWrapStyle] = useState({
        position: "absolute",
        transform: 'scale(' + ifloorplanObj.client_scale + ')',
        transformOrigin: 'top left'
        // top: `${ifloorplanObj.client_block_y}%`,
        // left: `${ifloorplanObj.client_block_x}%`,
    })

    const [camStyle, setCamStyle] = useState({
        position: "absolute",
        width: 6 + "%",
        top: "50%",
        left: "50%",
    })

    const [brandWrap, setBrandWrap] = useState({
        brand_pos_x: ifloorplanObj.brand_pos_x,
        brand_pos_y: ifloorplanObj.brand_pos_y,
        brand_width: ifloorplanObj.brand_width
    });
    const [crop, setCrop] = useState({
        unit: '%',
        x: ifloorplanObj.level[props.levelNowId].plan_level[0]?.crop_x * 100,
        y: ifloorplanObj.level[props.levelNowId].plan_level[0]?.crop_y * 100,
        width: ifloorplanObj.level[props.levelNowId].plan_level[0]?.crop_width * 100,
        height: ifloorplanObj.level[props.levelNowId].plan_level[0]?.crop_height * 100,
    });
    const [isCrop, setIsCrop] = useState(false);
    const [cropped, setCropped] = useState(null);
    const imgRef = useRef(null);
    const [cropImg, setCropImg] = useState();
    const [planSrc, setPlanSrc] = useState();
    const planRef = useRef();
    const imageRef = useRef();
    const brandRef = useRef();
    const addressRef = useRef();
    const clientRef = useRef();
    const markerRef = useRef();
    const rotateLeft = useRef();
    const rotateRight = useRef();
    const [lastCrop, setLastCrop] = useState();
    const [activeRnd, setActiveRnd] = useState({
        plan: false,
        image: false,
        brand: false,
        address: false,
        client: false,
    });
    const [isDone, setIsDone] = useState(false);
    const [planCropWrap, setPlanCropWrap] = useState();
    const [imageBounds, setImageBounds] = useState('');
    const [showDelete, setShowDelete] = useState('none');

    const [cropPos, setCropPos] = useState({
        x: ifloorplanObj.level[props.levelNowId].plan_level[0]?.crop_x,
        y: ifloorplanObj.level[props.levelNowId].plan_level[0]?.crop_y,
        width: ifloorplanObj.level[props.levelNowId].plan_level[0]?.crop_width,
        height: ifloorplanObj.level[props.levelNowId].plan_level[0]?.crop_height,
    })

    const enableResize = (active) => {
        return {
            top: false,
            left: false,
            right: false,
            bottom: false,
            topLeft: active,
            topRight: active,
            bottomLeft: active,
            bottomRight: active,
        }
    }

    const handleSelectImagesButtonClick = (event) => {
        event.preventDefault();
        props.nextStep("image library", "first");
    };

    const handleSelect360ImagesButtonClick = (event) => {
        event.preventDefault();
        props.nextStep("360 library", "first");
    };

    const cropPlan = (levelId, plan_array) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx.imageSmoothingQuality = 'high';
        let planImage = new Image();
        planImage.onload = () => {
            canvas.width = ifloorplanObj.level[levelId].plan_level[0].crop_width * planImage.naturalWidth;
            canvas.height = ifloorplanObj.level[levelId].plan_level[0].crop_height * planImage.naturalHeight;
            ctx.drawImage(
                planImage,
                ifloorplanObj.level[levelId].plan_level[0].crop_x * planImage.naturalWidth,
                ifloorplanObj.level[levelId].plan_level[0].crop_y * planImage.naturalHeight,
                ifloorplanObj.level[levelId].plan_level[0].crop_width * planImage.naturalWidth,
                ifloorplanObj.level[levelId].plan_level[0].crop_height * planImage.naturalHeight,
                0,
                0,
                ifloorplanObj.level[levelId].plan_level[0].crop_width * planImage.naturalWidth,
                ifloorplanObj.level[levelId].plan_level[0].crop_height * planImage.naturalHeight,
            );

            canvas.toBlob((blob) => {
                const blobURL = URL.createObjectURL(blob);
                plan_array[levelId] = blobURL;
                if (levelId === props.levelNowId)
                    if (plan_array[levelId]) setPlanSrc(plan_array[levelId]);
                    else props.nextStep("single plan upload", "_");
            })
        }
        planImage.crossOrigin = "Anonymous";
        planImage.src = ifloorplanObj.level[levelId].plan_level[0].img;
    }

    const cropAllPlans = () => {
        const plan_array = props.plans;
        for (let i = 0; i < ifloorplanObj.level.length; ++i) {
            cropPlan(i, plan_array);
        }
        props.addPlan(plan_array);
    }

    const tabsInit = () => {
        let tabs_ready = [];
        let media_tabs = [];
        if (ifloorplanObj.level.length == 1 && ifloorplanObj.media.length == 0) {
            return 1;
        }
        const tab_num = ifloorplanObj.level.length + ifloorplanObj.media.length;
        ifloorplanObj.level.map((value, index) => {
            if (index == props.levelNowId) {
                tabs_ready.push(<div className="tab active_tab" key={index}
                    style={{
                        zIndex: tab_num + 1,
                        fontSize: `${1.8 * viewHeight / 100}px`,
                        transform: `translateX(-${10 * index}px)`,
                    }}>{value.tabLabel}</div>)
            } else {
                tabs_ready.push(<div className="tab" onClick={() => {
                    if (ifloorplanObj.level[index].images.length > 0) {
                        props.changeImageKey(0); //reset image key
                        props.changePannellumKey(-1)
                    }
                    else if (ifloorplanObj.level[index].panelum.length > 0) {
                        props.changePannellumKey(0)
                        props.changeImageKey(-1);
                    }
                    else {
                        props.nextStep("upload images", "exist images");
                    }
                    props.changeLevel(index);
                }} key={index}
                    style={{
                        zIndex: tab_num - index,
                        transform: `translateX(-${10 * index}px)`,
                        fontSize: `${1.8 * viewHeight / 100}px`,
                    }}>{value.tabLabel}</div>)
            }
        });
        ifloorplanObj.media.map((value, index) => {
            media_tabs.push(<div className="tab" key={index}
                style={{
                    transform: `translateX(-${10 * (index + ifloorplanObj.level.length)}px)`,
                    fontSize: `${1.8 * viewHeight / 100}px`,
                }}>{value.label}</div>)
        })
        setMediaTabs(media_tabs);
        setTabs(tabs_ready);
    }

    const imagesArray = ifloorplanObj.level[props.levelNowId].images;
    const pannellumArray = ifloorplanObj.level[props.levelNowId].panelum;
    const PannellumCams = pannellumArray.map((value, index) => {
        if (index != props.pannellum_key && value.pos_x != 50) {
            if (value.button) return <ButtonMarker index={index} value={value} viewHeight={viewHeight} />
            else return <Marker
                index={index}
                value={value}
                img={ifloorplanObj.marker360_image}
                img_hover={ifloorplanObj.marker360_image_hover}
                width={ifloorplanObj.marker360_width}
                viewHeight={viewHeight}
                is_preview_marker_360={props.is_preview_marker_360} />
        }
    })

    const ifl_image = props.image_key >= 0 ? ifloorplanObj.level[props.levelNowId].images[props.image_key] : ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key];
    const Cams = imagesArray.map((value, index) => {

        if (index !== props.image_key && value?.cam_pos_x !== 0) {
            if (value.button) {
                return <ButtonMarker index={index} value={value}
                    viewHeight={viewHeight} />
            } else {
                return <Cam index={index} value={value}
                    img={ifloorplanObj.marker_image}
                    img_hover={ifloorplanObj.marker_image_hover}
                    width={ifloorplanObj.marker_width}
                    viewHeight={viewHeight}
                    is_preview_marker={props.is_preview_marker} />
            }
        }
    })

    const deleteCurrentMarker = () => {
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        if (props.image_key >= 0) {
            newState.level[props.levelNowId].images.splice(props.image_key, 1);
            props.ifloorplanStateAdd(newState);
            if (newState.level[props.levelNowId].images.length > 0)
                props.changeImageKey(0);
            else if (newState.level[props.levelNowId].panelum.length > 0) {
                props.changeImageKey(-1);
                props.changePannellumKey(0);
            }
            else {
                props.changeImageKey(-1);
                props.changePannellumKey(-1);
            }
        }
        else if (props.pannellum_key >= 0) {
            newState.level[props.levelNowId].panelum.splice(props.pannellum_key, 1);
            props.ifloorplanStateAdd(newState);
            if (newState.level[props.levelNowId].panelum.length > 0)
                props.changePannellumKey(0);
            else if (newState.level[props.levelNowId].images.length > 0) {
                props.changeImageKey(0);
                props.changePannellumKey(-1);
            }
            else {
                props.changeImageKey(-1);
                props.changePannellumKey(-1);
            }
        }
    }

    const init = () => {
        //set position frontend blocks
        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        props.changeCamPosition(newState);
        tabsInit(); //init tabs position

        //correction value
        const parrentBlock = document.getElementsByClassName("planWrap")[0];

        parrentBlock.style.color = ifloorplanObj.textColor;
        parrentBlock.style.background = ifloorplanObj.bgColor;

        const arrowL = document.getElementsByClassName("hoverBlockLeft")[0];
        const arrowR = document.getElementsByClassName("hoverBlockRight")[0];
        const arrow = document.getElementsByClassName("handle")[0];
        if (arrowL)
            arrowL.ondragstart = function () {   //disable drag in arrows
                return false;
            };
        if (arrowR)
            arrowR.ondragstart = function () {
                return false;
            };
        if (arrow)
            arrow.ondragstart = function () {
                return false;
            };
        const handleResizeScreen = () => {
            const screen_size_ratio = window.innerWidth / (window.innerHeight - 46);
            const w = screen_size_ratio < 1.7777 ? window.innerWidth * 99 / 100 : (window.innerHeight * 99 / 100 - 80) * 1.7777;
            const h = screen_size_ratio < 1.7777 ? window.innerWidth * 55.69 / 100 : (window.innerHeight * 99 / 100 - 80);
            [_width, _height] = screen_size_ratio < 1.7777 ? ["99vw", "55.69vw"] : ["calc((99vh - 80px) * 1.7777)", "calc(99vh - 80px)"];
            document.getElementsByClassName("dnd-wrapper")[0].style.width = _width;
            document.getElementsByClassName("dnd-wrapper")[0].style.height = _height;
            document.getElementsByClassName("workPlace")[0].style.width = _width;
            document.getElementsByClassName("workPlace")[0].style.height = _height;
            const new_view_height = screen_size_ratio < 1.7777 ? 55.69 * window.innerWidth / 100 : (99 * window.innerHeight / 100 - 80);
            setViewHeight(new_view_height);
            planRef.current && planRef.current.updatePosition({
                x: planRef.current.draggable.state.x * w / screenWidth,
                y: planRef.current.draggable.state.y * h / screenHeight,
            })
            planRef.current && planRef.current.updateSize({
                width: `${ifloorplanObj.level[props.levelNowId].plan_width}%`,
                height: 'auto',
            })
            imageRef.current.updatePosition({
                x: imageRef.current.draggable.state.x * w / screenWidth,
                y: imageRef.current.draggable.state.y * h / screenHeight,
            })
            brandRef.current && brandRef.current.updatePosition({
                x: brandRef.current.draggable.state.x * w / screenWidth,
                y: brandRef.current.draggable.state.y * h / screenHeight,
            })
            brandRef.current && brandRef.current.updateSize({
                width: `${ifloorplanObj.brand_width}%`,
                height: 'auto'
            })
            addressRef.current.updatePosition({
                x: addressRef.current.draggable.state.x * w / screenWidth,
                y: addressRef.current.draggable.state.y * h / screenHeight,
            })
            clientRef.current && clientRef.current.updatePosition({
                x: clientRef.current.draggable.state.x * w / screenWidth,
                y: clientRef.current.draggable.state.y * h / screenHeight,
            })
            clientRef.current && clientRef.current.updateSize({
                width: 80 * new_view_height / 100 * ifloorplanObj.client_scale + 'px',
                height: 20 * new_view_height / 100 * ifloorplanObj.client_scale + 'px',
            })
            screenSizeRatio = screen_size_ratio;
            screenWidth = w;
            screenHeight = h;
        }

        //init colors
        props.setColorBackground(newState.bgColor);
        props.setColorText(newState.textColor);
        if (props.setShowTools)
            props.setShowTools(true);
        cropAllPlans();
        window.addEventListener('resize', handleResizeScreen);
        const hideDeleteMarker = (e) => {
            if (!e.target.className.includes('handle')) {
                setShowDelete('none');
            }
        }
        document.addEventListener('click', hideDeleteMarker);

        return () => {
            window.removeEventListener('resize', handleResizeScreen);
        }
    };

    useEffect(() => {
        setCamStyle({
            ...camStyle,
            width: props.ifloorplanNowState.marker_width * viewHeight / 100 + "px",
        });
        tabsInit();
    }, [viewHeight]);

    const markerDragInit = () => {
        if (props.image_key >= 0) {
            markerRef.current && markerRef.current.updatePosition({ x: 0, y: 0 });
            if (imagesArray[props.image_key]?.cam_pos_x === 0) {
                setIsFirstMarker(true);
                setCamStyle({
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    width: ifloorplanObj.marker_width * viewHeight / 100 + "px"
                })
                const childBlock = document.getElementsByClassName("camPosSet")[0];
                childBlock.classList.add('bounces');
                document.getElementsByClassName("firstMarker-wrap")[0].classList.add('bounces');
                setTimeout(() => {
                    childBlock.classList.remove('bounces');
                    document.getElementsByClassName("firstMarker-wrap")[0]?.classList.remove('bounces');
                }, 1100)
                setRotation(0);
            } else {
                setIsFirstMarker(false);
                setCamStyle({
                    position: "absolute",
                    left: `${imagesArray[props.image_key]?.cam_pos_x}%`,
                    top: `${imagesArray[props.image_key]?.cam_pos_y}%`,
                    width: ifloorplanObj.marker_width * viewHeight / 100 + "px"
                })
                setRotation(ifloorplanObj.level[props.levelNowId].images[props.image_key]?.cam_rotation);
            }
        }
        else if (props.pannellum_key >= 0) {
            markerRef.current && markerRef.current.updatePosition({ x: 0, y: 0 });
            if (ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].pos_y === 50) {
                const childBlock = document.getElementsByClassName("camPosSet")[0];
                setIsFirstMarker(true);
                childBlock.classList.add('bounces');
                document.getElementsByClassName("firstMarker-wrap")[0].classList.add('bounces');
                setTimeout(() => {
                    childBlock.classList.remove('bounces');
                    document.getElementsByClassName("firstMarker-wrap")[0].classList.remove('bounces');
                }, 1100)
            }
            else {
                setIsFirstMarker(false);
            }
            setCamStyle({
                position: "absolute",
                top: `${ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].pos_y}%`,
                left: `${ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].pos_x}%`,
                width: `${ifloorplanObj.marker360_width * viewHeight / 100}px`,
            })
        }
    }

    useEffect(() => {
        //start when cams changed positions
        //1 hook - when changed global state array ifloorplan
        //2 hook - when changed global state cam key
        if (isCrop) return;
        markerDragInit();
    }, [props.image_key, props.pannellum_key]);

    useEffect(() => {
        markerRef.current && markerRef.current.updatePosition({ x: 0, y: 0 });
    }, [isCrop])

    useEffect(() => {
        if (props.pannellum_key >= 0) {
            setPanView({
                yaw: ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].yaw,
                pitch: ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].pitch,
                hfov: ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].hfov,
            })
            // let newState = JSON.parse(JSON.stringify(ifloorplanObj));
            // newState.level[props.levelNowId].panelum[props.pannellum_key].cam_img = "/media/markers/Group_63.png";
            // newState.level[props.levelNowId].panelum[props.pannellum_key].cam_img_hover = "/media/markers/Group_64.png";
            // props.ifloorplanStateAdd(newState);
        }
    }, [props.pannellum_key])

    useEffect(() => {
        //start when cams changed positions
        //1 hook - when changed global state array ifloorplan
        //2 hook - when changed global state cam key
        if (!ifloorplanObj.level[props.levelNowId].plan_level[0]) {
            console.log('this');
            props.nextStep("single plan upload", "_");
            return;
        }
        markerDragInit();
        setImageWrapStyle({
            ...imageWrapStyle,
            width: `${ifloorplanObj.img_width}%`,
            height: `${ifloorplanObj.img_height}%`,
            top: `${ifloorplanObj.img_pos_y}%`,
            left: `${ifloorplanObj.img_pos_x}%`,
        });
        imageRef.current.updatePosition({ x: 0, y: 0 });
        setPlanWrapStyle({
            ...planWrapStyle,
            width: ifloorplanObj.level[props.levelNowId].plan_width,
            top: ifloorplanObj.level[props.levelNowId].plan_pos_y,
            left: ifloorplanObj.level[props.levelNowId].plan_pos_x
        });
        setPlanSrc(props.plans[props.levelNowId]);
        setRotation(ifloorplanObj.level[props.levelNowId].images[props.image_key]?.cam_rotation);
        tabsInit(); //init tabs position
        markerRef.current && markerRef.current.updatePosition({ x: 0, y: 0 });
        planRef.current && planRef.current.updatePosition({
            x: screenWidth * ifloorplanObj.level[props.levelNowId].plan_pos_x / 100,
            y: screenHeight * ifloorplanObj.level[props.levelNowId].plan_pos_y / 100,
        });

        const image = new Image();
        image.src = ifloorplanObj.level[props.levelNowId].plan_level[0].img;
        image.onload = () => {
            setPlanImage({
                naturalWidth: image.width,
                naturalHeight: image.height
            })
        }

        init();
    }, [props.levelNowId]);

    const drag = (event) => {

        event.preventDefault();

        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        const childBlock = document.getElementsByClassName("camPosSet")[0];

        const parrentBlock = document.getElementsByClassName("planWrap")[0];
        let childX = childBlock.getBoundingClientRect().left;
        let childY = childBlock.getBoundingClientRect().top;
        const { top, left, width, height } = parrentBlock.getBoundingClientRect();

        let x = (childX - left) / width * 100;
        let y = (childY - top) / height * 100;

        markerRef.current.updatePosition({ x: 0, y: 0 });
        if (props.image_key >= 0) {
            newState.level[props.levelNowId].images[props.image_key].cam_pos_x = x;
            newState.level[props.levelNowId].images[props.image_key].cam_pos_y = y;
            newState.level[props.levelNowId].images[props.image_key].cam_rotation = rotation;
            setCamStyle({
                position: "absolute",
                left: `${x}%`,
                top: `${y}%`,
                width: props.ifloorplanNowState.marker_width * viewHeight / 100 + "px"
            })
        }
        else {
            newState.level[props.levelNowId].panelum[props.pannellum_key].pos_x = x;
            newState.level[props.levelNowId].panelum[props.pannellum_key].pos_y = y;
            setCamStyle({
                position: "absolute",
                left: `${x}%`,
                top: `${y}%`,
                width: `${props.ifloorplanNowState.marker360_width * viewHeight / 100}px`
            })
        }
        props.ifloorplanStateAdd(newState); //update main ifloorplan in global state

    }

    const getPosition = () => {
        let minx = 0, miny = 0, maxx = 100, maxy = 100;
        const imagesArray = props.ifloorplanNowState.level[props.levelNowId].images;
        const videoArray = props.ifloorplanNowState.level[props.levelNowId].video_marker;
        const panelumArray = props.ifloorplanNowState.level[props.levelNowId].panelum;
        const planBlock = document.getElementsByClassName("planWrap")[0]?.getBoundingClientRect();
        if (!planBlock) {
            return;
        }
        for (let i = 0; i < imagesArray.length; i++) {
            if (imagesArray[i].cam_pos_x !== 0) {
                minx = Math.min(minx, imagesArray[i].cam_pos_x);
                miny = Math.min(miny, imagesArray[i].cam_pos_y);
                maxx = Math.max(maxx, imagesArray[i].cam_pos_x);
                maxy = Math.max(maxy, imagesArray[i].cam_pos_y);
            }
        }
        for (let i = 0; i < videoArray.length; i++) {
            if (videoArray[i].pos_x !== 0) {
                minx = Math.min(minx, videoArray[i].pos_x);
                miny = Math.min(miny, videoArray[i].pos_y);
                maxx = Math.max(maxx, videoArray[i].pos_x);
                maxy = Math.max(maxy, videoArray[i].pos_y);
            }
        }
        for (let i = 0; i < panelumArray.length; i++) {
            if (panelumArray[i].pos_x !== 0) {
                minx = Math.min(minx, panelumArray[i].pos_x);
                miny = Math.min(miny, panelumArray[i].pos_y);
                maxx = Math.max(maxx, panelumArray[i].pos_x);
                maxy = Math.max(maxy, panelumArray[i].pos_y);
            }
        }
        const w_per_h = planBlock.width / planBlock.height;
        const w = maxx - minx, h = (maxy - miny) / w_per_h;

        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        let rect_width = w / h > 9 / 16 ? 95 : 1568 / 9 * w / h;
        let rect_height = rect_width * h / w * 9 / 16;
        newState.level[props.levelNowId].portrait_plan_width = 100 / w * rect_width;
        newState.level[props.levelNowId].portrait_plan_pos_x = (100 - rect_width) / 2 - minx / w * rect_width;
        newState.level[props.levelNowId].portrait_plan_pos_y = (100 - rect_height) / 2 - miny / (h * w_per_h) * rect_height;

        rect_width = w / h > 16 / 9 ? 95 : 882 / 16 * w / h;
        rect_height = rect_width * h / w * 16 / 9;
        newState.level[props.levelNowId].landscape_plan_width = 100 / w * rect_width;
        newState.level[props.levelNowId].landscape_plan_pos_x = (100 - rect_width) / 2 - minx / w * rect_width;
        newState.level[props.levelNowId].landscape_plan_pos_y = (100 - rect_height) / 2 - miny / (h * w_per_h) * rect_height;
        props.ifloorplanStateAdd(newState);
    }

    const onResizeClient = (event, direction, ref) => {
        event.preventDefault();
        const childBlock = document.getElementsByClassName(ref.className)[0];
        const parrentBlock = document.getElementsByClassName("dnd-wrapper")[0];
        const client_scale = childBlock.getBoundingClientRect().width / (80 * viewHeight / 100);
        let childX = childBlock.getBoundingClientRect().left;
        let childY = childBlock.getBoundingClientRect().top;
        let x = (childX - parrentBlock.getBoundingClientRect().left) / parrentBlock.getBoundingClientRect().width * 100; // get position at parsent
        let y = (childY - parrentBlock.getBoundingClientRect().top) / parrentBlock.getBoundingClientRect().height * 100;
        setClientWrapStyle({
            ...clientWrapStyle,
            top: y,
            left: x,
            transform: `scale(${client_scale})`
        });
    }

    const resizeHandle = (event, direction, ref) => {
        event.preventDefault();
        const parrentBlock = document.getElementsByClassName("dnd-wrapper")[0];
        const childBlock = document.getElementsByClassName(ref.className)[0];
        const width = childBlock.getBoundingClientRect().width / parrentBlock.getBoundingClientRect().width * 100;
        const height = childBlock.getBoundingClientRect().height / parrentBlock.getBoundingClientRect().height * 100;
        let childX = childBlock.getBoundingClientRect().left;
        let childY = childBlock.getBoundingClientRect().top;

        let x = (childX - parrentBlock.getBoundingClientRect().left) / parrentBlock.getBoundingClientRect().width * 100; // get position at parsent
        let y = (childY - parrentBlock.getBoundingClientRect().top) / parrentBlock.getBoundingClientRect().height * 100;
        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        switch (ref.className.split(' ')[0]) {
            case 'clientWrap':
                const client_scale = childBlock.getBoundingClientRect().width / (80 * viewHeight / 100)
                setClientWrapStyle({
                    ...clientWrapStyle,
                    top: y,
                    left: x,
                    transform: `scale(${client_scale})`
                });
                newState.client_scale = client_scale;
                newState.client_block_y = y;
                newState.client_block_x = x;
                break;
            case 'planWrap':
                setPlanWrapStyle({
                    ...planWrapStyle,
                    width: width,
                    top: y,
                    left: x,
                });
                newState.level[props.levelNowId].plan_pos_x = x;
                newState.level[props.levelNowId].plan_pos_y = y;
                newState.level[props.levelNowId].plan_width = width;
                break;
            case 'imageWrap':
                setImageWrapStyle({
                    ...imageWrapStyle,
                    width: `${width}%`,
                    height: `${height}%`,
                    top: `${y}%`,
                    left: `${x}%`,
                });
                newState.img_pos_x = x;
                newState.img_pos_y = y;
                newState.img_width = width;
                newState.img_height = height;
                imageRef.current.updatePosition({ x: 0, y: 0 });
                break;
            case 'brandWrap':
                setBrandWrap({
                    ...brandWrap,
                    brand_width: width,
                    brand_pos_y: y,
                    brand_pos_x: x,
                });
                newState.brand_pos_x = x;
                newState.brand_pos_y = y;
                newState.brand_width = width;
                break;
        }
        props.ifloorplanStateAdd(newState);
    }

    const dragHandle = (event) => {
        //set position block images
        event.preventDefault();
        // const block = document.querySelector(`.${event.target.className}`);
        let clientArray = ['client-logo', 'contact_name', 'contact_email', 'contact_phone'];
        let childBlock = document.getElementsByClassName(event.target.className)[0];
        if (clientArray.includes(event.target.className))
            childBlock = document.getElementsByClassName('clientWrap')[0];
        if (!childBlock) childBlock = document.getElementById(event.target.id);
        if (!childBlock) return;
        if (event.target.className.includes('pnlm')) childBlock = document.getElementsByClassName('imageWrap')[0];
        const parrentBlock = document.getElementsByClassName("dnd-wrapper")[0];
        let childX = childBlock.getBoundingClientRect().left;
        let childY = childBlock.getBoundingClientRect().top;
        const { top, left, width, height } = parrentBlock.getBoundingClientRect();

        let x = (childX - left) / width * 100; // get position at parsent
        let y = (childY - top) / height * 100;
        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        switch (event.target.className !== '' ? clientArray.includes(event.target.className) ? 'clientWrap' : event.target.className.includes('pnlm') ? 'imageWrap' : event.target.className : event.target.id) {
            case 'clientWrap':
                setClientWrapStyle({
                    ...clientWrapStyle,
                    top: y,
                    left: x,
                });
                newState.client_block_y = y;
                newState.client_block_x = x;
                break;
            case 'planWrap':
                setPlanWrapStyle({
                    ...planWrapStyle,
                    top: y,
                    left: x,
                });
                newState.level[props.levelNowId].plan_pos_x = x;
                newState.level[props.levelNowId].plan_pos_y = y;
                break;
            case 'imageWrap':
                setImageWrapStyle({
                    ...imageWrapStyle,
                    top: `${y}%`,
                    left: `${x}%`,
                });
                newState.img_pos_x = x;
                newState.img_pos_y = y;
                imageRef.current.updatePosition({ x: 0, y: 0 });
                break;
            case 'brandWrap':
                setBrandWrap({
                    ...brandWrap,
                    brand_pos_y: y,
                    brand_pos_x: x,
                });
                newState.brand_pos_x = x;
                newState.brand_pos_y = y;
                break;
            case 'addressWrap':
            case 'text_input':
                newState.addressPosition_x = x;
                newState.addressPosition_y = y;
                break;
        };
        setImageBounds('');
        props.ifloorplanStateAdd(newState);

    };

    useEffect(() => {
        if (!cropped || !imgRef.current || (cropped.width === 0 && cropped.height === 0))
            return;
        const canvas = document.createElement('canvas');
        const image = imgRef.current;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');
        canvas.width = cropped.width * scaleX;
        canvas.height = cropped.height * scaleY;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(
            image,
            cropped.x * scaleX,
            cropped.y * scaleY,
            cropped.width * scaleX,
            cropped.height * scaleY,
            0,
            0,
            cropped.width * scaleX,
            cropped.height * scaleY
        );
        const parrentBlock = document.getElementsByClassName('dnd-wrapper')[0].getBoundingClientRect();

        canvas.toBlob((blob) => {
            if (blob) {
                setCropImg({
                    img: URL.createObjectURL(blob),
                    width: cropped.width / parrentBlock.width * 100
                });
                setCropPos({
                    x: cropped.x * scaleX / planImage.naturalWidth,
                    y: cropped.y * scaleY / planImage.naturalHeight,
                    width: cropped.width * scaleX / planImage.naturalWidth,
                    height: cropped.height * scaleY / planImage.naturalHeight,
                })
            }
        })

    }, [cropped]);

    useEffect(() => {
        imageRef.current.updateSize({
            width: ifloorplanObj.img_width + "%",
            height: ifloorplanObj.img_height + "%",
        })

        planRef.current.updateSize({
            width: ifloorplanObj.level[props.levelNowId].plan_width + "%",
            height: 'auto',
        })
    }, [props.image_key, props.levelNowId])

    useEffect(() => {
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        // for (let i = 0; i < newState.level.length; i++) {
        //     for (let j = 0; j < newState.level[i].images.length; j++) {
        //         newState.level[i].images[j].cam_width = props.marker_width;
        //     }
        // }
        newState.marker_width = props.marker_width;

        props.ifloorplanStateAdd(newState);
        markerDragInit();
    }, [props.marker_width]);

    useEffect(() => {
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        // for (let i = 0; i < newState.level.length; i++) {
        //     for (let j = 0; j < newState.level[i].panelum.length; j++) {
        //         newState.level[i].panelum[j].cam_width = props.pan_marker_width;
        //     }
        // }
        newState.marker360_width = props.pan_marker_width;
        props.ifloorplanStateAdd(newState);
        markerDragInit();
    }, [props.pan_marker_width])


    const beginCrop = () => {
        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        newState.level[props.levelNowId].plan_pos_x = planWrapStyle.left;
        newState.level[props.levelNowId].plan_pos_y = planWrapStyle.top;
        props.ifloorplanStateAdd(newState);
        setCrop({
            x: cropPos.x * 100,
            y: cropPos.y * 100,
            width: cropPos.width * 100,
            height: cropPos.height * 100,
            unit: '%',
        })
        setLastCrop(cropPos);
        setIsCrop(true);
        document.getElementsByClassName('topPanelWrap')[0].style.opacity = 0;
    }

    const setRnd = (event) => {
        // event.preventDefault()
        let clientArray = ['client-logo', 'contact_name', 'contact_email', 'contact_phone', 'logo-wrapper'];
        setActiveRnd({
            plan: event.target.className === 'planWrap',
            image: event.target.className === 'imageWrap' || event.target.className === 'pnlm-dragfix',
            brand: event.target.className === 'brandWrap',
            address: event.target.className === 'edit-text-block',
            client: clientArray.includes(event.target.className),
        });

        if (event.detail === 2) {
            if (event.target.className === 'planWrap' && !isCrop) {
                beginCrop();
            }
            else {
                setIsDone(true);
                setIsPanning(false);
                document.getElementsByClassName('topPanelWrap')[0].style.opacity = 1;
            }

            if (event.target.className === 'pnlm-dragfix') {
                togglePanView();
            }
        }
    }

    const CornerHandle = (<>
        <div className="top-left" />
        <div className="bottom-left" />
        <div className="top-right" />
        <div className="bottom-right" />
    </>);

    useEffect(() => {
        let plan = document.getElementsByClassName("planWrap")[0]?.getBoundingClientRect();
        const handle = setInterval(() => {
            let value = document.getElementsByClassName("planWrap")[0]?.getBoundingClientRect();
            if (JSON.stringify(value) === JSON.stringify(plan)) {
                clearInterval(handle);
                if (!ifloorplanObj.viewed_mobile_editor) {
                    getPosition();
                }
            }
            else plan = value;
        }, 100);
        setPlanOffset();
    }, [planSrc]);

    useEffect(() => {
        if (planCropWrap && (props.prev_step === "plan library" || props.prev_step === "not redirect lib")) {
            props.nextStep(props.step, '_');
            setActiveRnd({
                plan: true,
                image: false,
                brand: false,
                address: false,
                client: false,
            })
        }
    }, [planCropWrap])

    const setPlanOffset = () => {
        if (!planSrc) return;
        let img = document.createElement('img');
        img.src = planSrc;
        const wait = setInterval(() => {
            if (img.naturalHeight !== 0 && planImage.naturalWidth !== 0) {
                const plan = document.getElementById('planWrap')?.getBoundingClientRect();
                if (plan) {
                    setPlanCropWrap({
                        ratio: img.naturalWidth / planImage.naturalWidth,
                        x: -ifloorplanObj.level[props.levelNowId].plan_level[0].crop_x * planImage.naturalWidth * plan.width / img.naturalWidth,
                        y: -ifloorplanObj.level[props.levelNowId].plan_level[0].crop_y * planImage.naturalHeight * plan.height / img.naturalHeight,
                    })
                    clearInterval(wait);
                }
            }
        }, 100)
    }

    const HandleDragStartStop = (event) => {
        event.preventDefault();
    }

    useEffect(() => {
        if (props.pannellum_key >= 0) {
            let newState = JSON.parse(JSON.stringify(ifloorplanObj));
            newState.level[props.levelNowId].panelum[props.pannellum_key].yaw = panView.yaw;
            newState.level[props.levelNowId].panelum[props.pannellum_key].pitch = panView.pitch;
            newState.level[props.levelNowId].panelum[props.pannellum_key].hfov = panView.hfov;
            props.ifloorplanStateAdd(newState);
        }
    }, [panView])

    const startRotateLeft = (e) => {
        e.preventDefault()
        if (rotateLeft.current) return;
        const delta = e.shiftKey ? 90 : 1;
        setRotation((prev_rotation) => (prev_rotation - delta + 360) % 360);
        rotateLeft.current = setInterval(() => {
            setRotation((prev_rotation) => (prev_rotation - delta + 360) % 360);
        }, e.shiftKey ? 500 : 20)
    }

    const stopRotateLeft = (e) => {
        e.preventDefault()
        if (rotateLeft.current) {
            clearInterval(rotateLeft.current);
            rotateLeft.current = null;
            let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
            newState.level[props.levelNowId].images[props.image_key].cam_rotation = rotation;
            props.ifloorplanStateAdd(newState);
        }
    }

    const startRotateRight = (e) => {
        e.preventDefault();
        if (rotateRight.current) return;
        const delta = e.shiftKey ? 90 : 1;
        setRotation((prev_rotation) => (prev_rotation + delta) % 360);
        rotateRight.current = setInterval(() => {
            setRotation((prev_rotation) => (prev_rotation + delta) % 360);
        }, e.shiftKey ? 500 : 20)
    }

    const stopRotateRight = (e) => {
        e.preventDefault();
        if (rotateRight.current) {
            clearInterval(rotateRight.current);
            rotateRight.current = null;
            let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
            newState.level[props.levelNowId].images[props.image_key].cam_rotation = rotation;
            props.ifloorplanStateAdd(newState);
        }
    }

    const togglePanView = () => {
        setActiveRnd({
            ...activeRnd,
            image: !activeRnd.image,
        });
        document.getElementsByClassName('topPanelWrap')[0].style.opacity = isPanning ? 1 : 0;
        setIsPanning(!isPanning);
    }

    return (
        <div className="workPlace" style={{ background: props.background_color, width: _width, height: _height }}>
            <div className="dnd-wrapper" style={{ width: _width, height: _height }}
                onClick={setRnd}>
                {ifloorplanObj.level[props.levelNowId].plan_level[0] &&
                    <CropTool planCropWrap={planCropWrap}
                        setPlanWrapStyle={setPlanWrapStyle}
                        setPlanSrc={setPlanSrc}
                        cropImg={cropImg}
                        setPlanCropWrap={setPlanCropWrap}
                        cropped={cropped}
                        imgRef={imgRef}
                        isCrop={isCrop}
                        setIsCrop={setIsCrop}
                        setCropPos={setCropPos}
                        lastCrop={lastCrop}
                        isDone={isDone}
                        setIsDone={setIsDone}
                        cropPos={cropPos}
                        setCamStyle={setCamStyle}
                    />}
                <Pan360Tool isPanning={isPanning}
                    togglePanView={togglePanView} />

                {ifloorplanObj.client_data == "" ? '' :
                    <Rnd
                        className="clientWrap"
                        onResize={onResizeClient}
                        onResizeStop={resizeHandle}
                        onDragStop={dragHandle}
                        onDragStart={HandleDragStartStop}
                        default={{
                            x: screenWidth * ifloorplanObj.client_block_x / 100,
                            y: screenHeight * ifloorplanObj.client_block_y / 100,
                            width: 80 * viewHeight / 100 * ifloorplanObj.client_scale + 'px',
                            height: 20 * viewHeight / 100 * ifloorplanObj.client_scale + 'px',
                        }}
                        style={{
                            position: 'absolute',
                        }}
                        lockAspectRatio={true}
                        enableResizing={enableResize(activeRnd.client)}
                        ref={clientRef}>
                        <div className="client_wrap_main" style={{
                            transform: clientWrapStyle.transform,
                            transformOrigin: 'top left',
                            height: 20 * viewHeight / 100 + 'px',
                            width: 80 * viewHeight / 100 + 'px',
                            outline: activeRnd.client ? `${4 / ifloorplanObj.client_scale}px solid #48C1F4` : "",
                        }}>
                            <Client clientData={JSON.parse(ifloorplanObj.client_data)}
                                clientPosition={JSON.parse(ifloorplanObj.client_position)}
                                viewHeight={viewHeight} />
                        </div>
                        {activeRnd.client && CornerHandle}
                    </Rnd>
                }

                <div className="tabs" style={tabsStyle}>
                    {tabs}
                    {mediaTabs}
                </div>
                <Rnd
                    className="imageWrap"
                    onResizeStop={resizeHandle}
                    onResize={(e) => {
                        setResizingImage(prev => prev + 1);
                    }}
                    onDragStart={(e) => {
                        e.preventDefault();
                    }}
                    onDragStop={dragHandle}
                    style={{
                        position: "absolute",
                        outline: activeRnd.image ? "4px solid #48C1F4" : "",
                        zIndex: 1, /* z-index is 1 here because image should always be on top of plan and below modal */
                        ...imageWrapStyle,
                    }}
                    bounds={imageBounds}
                    lockAspectRatio={false}
                    enableResizing={activeRnd.image}
                    disableDragging={isPanning}
                    ref={imageRef}
                    allowAnyClick={props.pannellum_key >= 0}>
                    {props.image_key >= 0 ?
                        <div className="imageWrap"
                            style={{
                                width: "100%",
                                height: "100%",
                            }}>
                            <img className='imageWrap'
                                src={ifloorplanObj.level[props.levelNowId].images[props.image_key]?.img || null}
                                style={{
                                    width: '100%',
                                    height: "100%",
                                    objectFit: "contain",
                                }} />
                        </div>
                        : props.pannellum_key >= 0 ?
                            <>
                                <Pannellum
                                    width="100%"
                                    image={
                                        props.ifloorplanNowState.level[props.levelNowId].panelum[props.pannellum_key]?.img
                                    }
                                    pitch={ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].pitch}
                                    height={imageRef.current && (imageRef.current.resizable.state.height !== 'auto') ? '100%' : screenWidth * ifloorplanObj.img_width / 160}
                                    yaw={ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].yaw}
                                    hfov={ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].hfov}
                                    autoLoad
                                    data={ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key]}
                                    event="animatefinished"
                                    handleEvent={(finalPan) => {
                                        if (finalPan.hfov == 50 && panView.hfov == 100) return;
                                        setPanView(finalPan);
                                    }}
                                    draggable={isPanning}
                                    imageRef={imageRef}
                                    resizingImage={resizingImage}
                                    openImage={true}
                                />
                                <img className="pan-360-btn"
                                    src="/static/public/img/pan-360.png"
                                    style={{
                                        display: (activeRnd.image && !isPanning) ? 'block' : 'none',
                                        top: (parseFloat(imageWrapStyle.top) < 0) ? '100%' : '-4vh',
                                        transform: `translate(-50%, ${(parseFloat(imageWrapStyle.top) < 0) ? '25%' : '-25%'})`
                                    }}
                                    onClick={togglePanView} />
                            </>

                            :
                            <div className="imageWrap"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                }}>
                                <button
                                    onClick={handleSelectImagesButtonClick}
                                    style={{
                                        position: 'absolute',
                                        top: '30%',
                                        left: '50%',
                                        transform: 'translate(-50%, -30%)',
                                    }}
                                >
                                    Select Images
                                </button>
                                <button
                                    onClick={handleSelect360ImagesButtonClick}
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                    }}
                                >
                                    Select 360 Images
                                </button>
                                <img className='imageWrap'
                                    src="/static/public/img/_placeholder.png"
                                    style={{
                                        width: '100%',
                                        height: "100%",
                                        objectFit: "contain",
                                    }} />
                            </div>}

                    {activeRnd.image && CornerHandle}
                </Rnd>

                {!isCrop &&
                    <Rnd
                        className="planWrap"
                        style={{
                            position: "absolute",
                            outline: activeRnd.plan ? "4px solid #48C1F4" : "",
                        }}
                        onResizeStop={resizeHandle}
                        onDragStart={HandleDragStartStop}
                        onDragStop={dragHandle}
                        default={{
                            x: screenWidth * ifloorplanObj.level[props.levelNowId].plan_pos_x / 100,
                            y: screenHeight * ifloorplanObj.level[props.levelNowId].plan_pos_y / 100,
                        }}
                        size={{ width: planWrapStyle.width + "%", }}
                        lockAspectRatio={true}
                        enableResizing={enableResize(activeRnd.plan)}
                        cancel='.handle, .cam'
                        ref={planRef}>
                        <div className="planWrap">
                            {Cams}
                            {PannellumCams}

                            <Rnd
                                onDragStop={drag}
                                onDragStart={(e) => {
                                    HandleDragStartStop(e);
                                    setIsFirstMarker(false);
                                }}
                                enableResizing={false}
                                style={{
                                    top: camStyle.top,
                                    left: camStyle.left,
                                    zIndex: 124,
                                }}
                                ref={markerRef}
                                onContextMenu={(e) => {
                                    e.preventDefault();
                                    setShowDelete(prev => prev === 'none' ? 'block' : 'none');
                                }}
                                id="1">
                                <div className="firstMarker-wrap" style={{ display: isFirstMarker ? 'block' : 'none' }} />
                                {props.image_key >= 0 ? ifl_image?.button ?
                                    <div className="camPosSet" style={{
                                        width: camStyle.width,
                                        position: camStyle.position,
                                        // transform: "translate(-50%, -50%)",
                                    }}>
                                        <button className="handle" style={{
                                            background: ifl_image?.button_bg,
                                            color: ifl_image?.button_color_text,
                                            transform: `scale(${ifl_image?.button_scale})`,
                                            fontSize: `${ifl_image?.button_font_size * viewHeight / 100}px`,
                                            width: `${ifl_image?.button_width * viewHeight / 100}px`,
                                            height: `${ifl_image?.button_height * viewHeight / 100}px`,
                                            borderRadius: ifl_image?.button_radius + "vh",
                                            fontWeight: ifl_image?.button_font_weight,
                                            fontStyle: ifl_image?.button_font_style,
                                            fontFamily: ifl_image?.button_font_family,
                                            border: "2px solid red"
                                        }}
                                            id={ifl_image?.id}>
                                            {ifl_image?.button_label}
                                        </button>
                                    </div>

                                    :

                                    <div className="camPosSet" style={{
                                        width: camStyle.width,
                                        position: camStyle.position,
                                    }}>
                                        <img className="handle" style={{
                                            width: "100%",
                                            transform: `rotate(${rotation}deg) translate(-50%, -50%)`,
                                            zIndex: 12,
                                            position: "relative",
                                            transformOrigin: "top left"
                                        }}
                                            src={ifloorplanObj.marker_image}
                                            alt=""
                                            draggable={false}
                                            id={ifloorplanObj.level[props.levelNowId].images[props.image_key]?.id} />

                                        <div style={{
                                            display: "flex",
                                            position: "absolute",
                                            height: "300%",
                                            width: "170%",
                                            top: "-150%",
                                            left: "-170%"
                                        }}
                                            onMouseDown={startRotateLeft}
                                            onMouseUp={stopRotateLeft}
                                            className="hoverBlockLeft"
                                            onMouseOut={() => {
                                                setHoverBlockLeft(false)
                                            }}
                                            onMouseEnter={() => {
                                                setHoverBlockLeft(true)
                                            }}>
                                            {hoverBlockLeft ? (
                                                <img src="/media/ifloorplans_source/icon-rotater-left_over.svg" alt=""
                                                    style={{ width: "100%", height: "100%" }} />
                                            ) : (
                                                <img src="/media/ifloorplans_source/icon-rotater-left.svg" alt=""
                                                    style={{ width: "100%", height: "100%" }} />
                                            )
                                            }
                                        </div>
                                        <div style={{
                                            display: "flex",
                                            position: "absolute",
                                            height: "300%",
                                            width: "170%",
                                            top: "-150%",
                                        }}
                                            onMouseDown={startRotateRight}
                                            onMouseUp={stopRotateRight}
                                            className="hoverBlockRight"
                                            onMouseOut={() => {
                                                setHoverBlockRight(false)
                                            }}
                                            onMouseEnter={() => {
                                                setHoverBlockRight(true)
                                            }}>
                                            {hoverBlockRight ? (
                                                <img src="/media/ifloorplans_source/icon-rotater-right_over.svg" alt=""
                                                    style={{ width: "100%", height: "100%" }} />
                                            ) : (
                                                <img src="/media/ifloorplans_source/icon-rotater-right.svg" alt=""
                                                    style={{ width: "100%", height: "100%" }} />
                                            )
                                            }

                                        </div>
                                    </div>
                                    : props.pannellum_key >= 0 ? ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key].button ?
                                        <div className="camPosSet" style={{
                                            width: camStyle.width,
                                            position: camStyle.position,
                                        }}><button className="handle"
                                            style={{
                                                background: ifl_image?.button_bg,
                                                color: ifl_image?.button_color_text,
                                                transform: `scale(${ifl_image?.button_scale})`,
                                                fontSize: `${ifl_image?.button_font_size * viewHeight / 100}px`,
                                                width: `${ifl_image?.button_width * viewHeight / 100}px`,
                                                height: `${ifl_image?.button_height * viewHeight / 100}px`,
                                                borderRadius: ifl_image?.button_radius + "vh",
                                                fontWeight: ifl_image?.button_font_weight,
                                                fontStyle: ifl_image?.button_font_style,
                                                fontFamily: ifl_image?.button_font_family,
                                                border: "2px solid red"
                                            }}>{ifl_image?.button_label}
                                            </button>
                                        </div>
                                        :
                                        <div className="camPosSet" style={{
                                            width: camStyle.width,
                                            position: camStyle.position,
                                        }}>
                                            <img className="handle"
                                                src={ifloorplanObj.marker360_image}
                                                style={{
                                                    width: "100%",
                                                    transform: "translate(-50%, -50%)",
                                                }}
                                                draggable={false}
                                                id={ifloorplanObj.level[props.levelNowId].panelum[props.pannellum_key]?.id} />
                                        </div> : ''}
                                <div className="delete_marker"
                                    style={{
                                        display: showDelete,
                                        transform: props.pannellum_key >= 0 ? `translateY(100%)` : `none`,
                                    }}
                                    onClick={deleteCurrentMarker}>
                                    Remove marker and image
                                </div>
                            </Rnd>
                            <img className='planWrap' id='planWrap'
                                src={planSrc}
                                style={{
                                    width: '100%',
                                }} />
                        </div>
                        {activeRnd.plan && CornerHandle}
                        <div className="cropBtn"
                            style={{
                                display: activeRnd.plan ? 'flex' : 'none',
                                top: (planRef.current && planRef.current.draggable.state.y < 0) ? '100%' : '-4vh',
                                transform: `translate(-50%, ${(planRef.current && planRef.current.draggable.state.y < 0) ? '25%' : '-25%'})`,
                            }}
                            onClick={() => beginCrop()}>
                            <p style={{ marginRight: "5px", color: "#000" }}>Crop</p>
                            <img src="/static/public/img/floorplan-crop-symbol.png" />
                        </div>
                    </Rnd>}
                {isCrop &&
                    <div style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.25)",
                        zIndex: 999,
                    }}>
                        <ReactCrop
                            className="planWrap"
                            src={ifloorplanObj.level[props.levelNowId].plan_level[0].img}
                            onImageLoaded={(img) => {
                                imgRef.current = img;
                            }}
                            crop={crop}
                            style={{
                                position: "absolute",
                                top: planWrapStyle.top + "%",
                                left: planWrapStyle.left + "%",
                                width: planWrapStyle.width / planCropWrap.ratio + "%",
                                height: "auto",
                                transform: `translate(${planCropWrap.x}px, ${planCropWrap.y}px)`,
                            }}
                            onComplete={(crop) => { if (crop.width != 0 && crop.height != 0) setCropped(crop) }}
                            onChange={(crop) => { setCrop(crop) }}
                            crossorigin="anonymous"
                        />
                    </div>
                }
                {ifloorplanObj.brand_logo == null ? "" :
                    <Rnd
                        className="brandWrap"
                        style={{ position: "absolute" }}
                        onResizeStop={resizeHandle}
                        onDragStart={HandleDragStartStop}
                        onDragStop={dragHandle}
                        default={{
                            x: ifloorplanObj.brand_pos_x * screenWidth / 100,
                            y: ifloorplanObj.brand_pos_y * screenHeight / 100,
                            width: ifloorplanObj.brand_width + '%'
                        }}
                        lockAspectRatio={true}
                        enableResizing={activeRnd.brand}
                        ref={brandRef}>
                        <div className="brandWrap" style={{ opacity: ifloorplanObj.brand_transparency, outline: activeRnd.brand && "4px solid #48C1F4" }}>
                            <img className="brandWrap" style={{ width: '100%' }} src={ifloorplanObj.brand_logo || null} alt="" />
                        </div>
                    </Rnd>
                }
                <Rnd
                    className="edit-text-block"
                    style={{
                        position: "absolute",
                        color: props.textColor,
                    }}
                    default={{
                        x: screenWidth * addressWrapStyle.left / 100,
                        y: screenHeight * addressWrapStyle.top / 100,
                    }}
                    onDragStart={HandleDragStartStop}
                    onDragStop={dragHandle}
                    enableResizing={false}
                    disableDragging={document.getElementsByClassName("wrap_text_editor_main").length > 0 && document.getElementsByClassName("wrap_text_editor_main")[0].style.display === "block"}
                    ref={addressRef}>
                    <EditTextBlock
                        rndState={addressRef.current ? addressRef.current.draggable.state : null}
                        viewHeight={viewHeight}
                    />
                </Rnd>
            </div>
        </div>
    )
}

const putState = (state) => {
    return {
        step: state.step,
        prev_step: state.prev_step,
        levelNowId: state.levelNowId,
        cam_key: state.cam_key,
        image_key: state.image_key,
        positionCams: state.positionCams,
        ifloorplanNowState: state.ifloorplanNowState,
        text_color: state.text_color,
        background_color: state.background_color,
        set_color: state.set_color,
        plans: state.plans,
        pannellum_key: state.pannellum_key,
        marker_width: state.marker_width,
        pan_marker_width: state.pan_marker_width,
        is_preview_marker: state.is_preview_marker,
        is_preview_marker_360: state.is_preview_marker_360,
    }
}

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        changeCamKey: (key) => dispatch(changeCamKey(key)),
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan)),
        changeCamPosition: (obj) => dispatch(changeCamPosition(obj)),
        setColor: (bool) => dispatch(setColor(bool)),
        changeLevel: (level) => dispatch(changeLevel(level)),
        changeImageKey: (key) => dispatch(changeImageKey(key)),
        setColorBackground: (color) => dispatch(setColorBackground(color)),
        setColorText: (color) => dispatch(setColorText(color)),
        addPlan: (plan) => dispatch(addPlan(plan)),
        changePannellumKey: (key) => dispatch(changePannellumKey(key)),
    }
}
export default connect(putState, putActions)(CamsPosition);
